export const isAppScripts = window.env.APP_BROKERFRONT_APP_SCRIPTS === true ||
  window.env.APP_BROKERFRONT_APP_SCRIPTS === 'true' ||
  window.env.APP_BROKERFRONT_APP_SCRIPTS === 1 ||
  window.env.APP_BROKERFRONT_APP_SCRIPTS === '1';
